export default Object.freeze({
  SHOW_TOAST: 'toast/SHOW',
  HIDE_TOAST: 'toast/HIDE',
  REMOVE_TOAST: 'toast/REMOVE',
  CLICK_TOAST: 'toast/CLICK',
  RECEIVE_NOTIFICATIONS_SUCCESS: 'RECEIVE_NOTIFICATIONS_SUCCESS',
  RECEIVE_TOKEN_SUCCESS: 'RECEIVE_TOKEN_SUCCESS',
  SEARCH_USER_NOTIFICATIONS_SUCCESS: 'SEARCH_USER_NOTIFICATIONS_SUCCESS',
  SEARCH_USER_NOTIFICATIONS_REQUEST: 'SEARCH_USER_NOTIFICATIONS_REQUEST',
  FETCH_USER_NOTIFICATIONS_SUCCESS: 'FETCH_USER_NOTIFICATIONS_SUCCESS',
  FETCH_USER_NOTIFICATIONS_REQUEST: 'FETCH_USER_NOTIFICATIONS_REQUEST',
  CREATE_PAYMENT_RUN_SUCCESS: 'CREATE_PAYMENT_RUN_SUCCESS',
  CREATE_PAYMENT_RUN_FAILURE: 'CREATE_PAYMENT_RUN_FAILURE',
  UPDATE_NOTIFICATION_READ_SUCCESS: 'UPDATE_NOTIFICATION_READ_SUCCESS',
  UPDATE_BULK_NOTIFICATION_READ_SUCCESS:
    'UPDATE_BULK_NOTIFICATION_READ_SUCCESS',
  UPDATE_BULK_NOTIFICATION_READ_FAILURE:
    'UPDATE_BULK_NOTIFICATION_READ_FAILURE',
  UPDATE_BULK_NOTIFICATION_READ_REQUEST:
    'UPDATE_BULK_NOTIFICATION_READ_REQUEST',
  CLEAR_NOTIFICATIONS_PAYLOAD: 'CLEAR_NOTIFICATIONS_PAYLOAD',
  NOTIFY_FETCH_ACCOUNT_ERROR: 'NOTIFY_FETCH_ACCOUNT_ERROR',
  NOTIFY_WEBSOCKET_MESSAGE_SUCCESS: 'NOTIFY_WEBSOCKET_MESSAGE_SUCCESS',
});
